export enum CategoryPurposeCode {
  BONU = 'BONU',
  CASH = 'CASH',
  CBLK = 'CBLK',
  CCRD = 'CCRD',
  CGWV = 'CGWV',
  CIPC = 'CIPC',
  CONC = 'CONC',
  CORT = 'CORT',
  CTDF = 'CTDF',
  DCRD = 'DCRD',
  DIVI = 'DIVI',
  DVPM = 'DVPM',
  EPAY = 'EPAY',
  FCDT = 'FCDT',
  FCIN = 'FCIN',
  FCOL = 'FCOL',
  GOVT = 'GOVT',
  GP2P = 'GP2P',
  HEDG = 'HEDG',
  ICCP = 'ICCP',
  IDCP = 'IDCP',
  INTC = 'INTC',
  INTE = 'INTE',
  LBOX = 'LBOX',
  LOAN = 'LOAN',
  MP2B = 'MP2B',
  MP2P = 'MP2P',
  OTHR = 'OTHR',
  PENS = 'PENS',
  RPRE = 'RPRE',
  RRCT = 'RRCT',
  RVPM = 'RVPM',
  SALA = 'SALA',
  SAVG = 'SAVG',
  SECU = 'SECU',
  SSBE = 'SSBE',
  SUPP = 'SUPP',
  SWEP = 'SWEP',
  TAXS = 'TAXS',
  TOPG = 'TOPG',
  TRAD = 'TRAD',
  TREA = 'TREA',
  VATX = 'VATX',
  VOST = 'VOST',
  WHLD = 'WHLD',
  ZABA = 'ZABA',
}
